// Mirrors GolfPlayed.Domain.Helpers.Constants.InvoiceStatusConstants on the backend.
// InvoiceStatus is a seeded lookup table with no housekeeping screen of its own,
// so the fixed ids/labels are kept in sync here rather than fetched from an API.

export const InvoiceStatusConstants = {
  CREATED_ID: 'a3b4c5d6-1111-4e5f-8a9b-0c1d2e3f4a5b',
  PAID_ID: 'a3b4c5d6-2222-4e5f-8a9b-0c1d2e3f4a5b',
  CANCELLED_ID: 'a3b4c5d6-3333-4e5f-8a9b-0c1d2e3f4a5b',
};

export const INVOICE_STATUS_OPTIONS = [
  { value: InvoiceStatusConstants.CREATED_ID, label: 'Created' },
  { value: InvoiceStatusConstants.PAID_ID, label: 'Paid' },
  { value: InvoiceStatusConstants.CANCELLED_ID, label: 'Cancelled' },
];

export const invoiceStatusLabel = (id?: string): string =>
  INVOICE_STATUS_OPTIONS.find((o) => o.value === id)?.label || '';
